<template>
  <tabs-list :tabs="tabs">
    <template v-slot:[`tab.prices`]>
      <prices-page />
    </template>
    <template v-slot:[`tab.checkInOut`]>
      <check-in-out />
    </template>
    <template v-slot:[`tab.placingVariants`]>
      <placing-variants />
    </template>
    <template v-slot:[`tab.serviceGroups`]>
      <service-groups />
    </template>
  </tabs-list>
</template>

<script setup lang="ts">
import type { TabsListTab } from '@/core/types/components/components';
import TabsList from '@/core/components/interface/Tabs.vue';
import CheckInOut from '@/parts/tariffs/components/PricesAndRestrictions/CheckInOut/index.vue';
import PlacingVariants from '@/parts/tariffs/components/PricesAndRestrictions/PlacingVariants/index.vue';
import PricesPage from '@/parts/tariffs/components/PricesAndRestrictions/PricesPage.vue';
import ServiceGroups from '@/parts/tariffs/components/PricesAndRestrictions/ServiceGroups/index.vue';

const tabs: TabsListTab[] = [
  {
    title: 'Цены',
    key: 'prices',
  },
  {
    title: 'Расчетные часы',
    key: 'checkInOut',
  },
  {
    title: 'Ограничения ВР',
    key: 'placingVariants',
  },
  {
    title: 'Ограничения ГУ',
    key: 'serviceGroups',
  },
];
</script>
